import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const NewGlobalFunnelReport = lazy(() =>
  import("@scenes/GlobalFunnelReports/NewGlobalFunnelReport/NewGlobalFunnelReport").then((module) => ({
    default: module.NewGlobalFunnelReport,
  }))
);

export const newGlobalFunnelReportNRO: NavigationRoutingObject = {
  Component: NewGlobalFunnelReport,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) => t("new-funnel-report-nro-heading", "New Funnel Report"),
  pageNameForTracking: () => "New Funnel Report",
  getDeveloperNavigationAllowed: ({ featureOn, isImpersonating, hasPermission }) => {
    const userHasEditReportingPermission = hasPermission("appGroup", {
      permission: "editReporting",
    });
    return featureOn("global_funnel_reports") && (isImpersonating || userHasEditReportingPermission);
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/funnel_reports/new/:appGroupId",
};
